import { Checkbox } from '@/components/ui-kit/checkbox';
import { Skeleton } from '@/components/ui-kit/skeleton';
import { cn } from '@/lib/utils';

interface CheckboxListOption {
  value: string;
  label: string;
}

export interface CheckboxListProps {
  options: CheckboxListOption[];
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  className?: string;
  /** The options come from the API and are still loading: placeholder tiles instead of none. */
  isLoading?: boolean;
}

/** Scrollable multi-select rendered as a responsive grid of checkbox tiles (lookups such as roles / languages). */
export const CheckboxList = ({
  options,
  value,
  onChange,
  disabled,
  className,
  isLoading = false,
}: CheckboxListProps) => (
  <div
    className={cn(
      'grid max-h-80 grid-cols-1 gap-2 overflow-y-auto sm:grid-cols-2 xl:grid-cols-3',
      className
    )}
    aria-busy={isLoading || undefined}
  >
    {isLoading &&
      options.length === 0 &&
      Array.from({ length: 6 }, (_, index) => (
        <Skeleton key={index} className="h-9 w-full rounded-md" />
      ))}
    {options.map((option) => (
      <label
        key={option.value}
        className="flex min-h-9 cursor-pointer items-center gap-2.5 rounded-md border border-input px-3 py-2 text-sm transition-colors hover:bg-muted has-[[data-state=checked]]:border-primary/40 has-[[data-state=checked]]:bg-accent has-[[data-disabled]]:cursor-not-allowed has-[[data-disabled]]:border-disabled-border has-[[data-disabled]]:bg-disabled has-[[data-disabled]]:text-disabled-foreground"
      >
        <Checkbox
          disabled={disabled}
          checked={value.includes(option.value)}
          onCheckedChange={(checked) =>
            onChange(
              checked ? [...value, option.value] : value.filter((item) => item !== option.value)
            )
          }
        />
        <span className="min-w-0 break-words">{option.label}</span>
      </label>
    ))}
  </div>
);
